module.exports = __webpack_public_path__ + "img/light_likeIcon.409c0cc7.svg";